module.exports = __webpack_public_path__ + "img/bq-his.67c2fcb4.png";